import type { FunctionalComponent } from 'preact';

import { cnHtmlText } from './html-text.constants.js';

import './html-text.css';

type BlockAttributes = {
    html?: string;
};

export interface RichTextProps extends BlockAttributes {}

export const HtmlText: FunctionalComponent<RichTextProps> = ({ html }) => {
    return (
        <span
            className={cnHtmlText({})}
            dangerouslySetInnerHTML={{
                __html: html ?? '',
            }}
        />
    );
};
